module.exports = __webpack_public_path__ + "img/IDEA_color.feb87a3a.svg";